var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M15.4665 15.4667L11.1999 11.2M6.9332 13.3333C3.39858 13.3333 0.533203 10.468 0.533203 6.93334C0.533203 3.39872 3.39858 0.53334 6.9332 0.53334C10.4678 0.53334 13.3332 3.39872 13.3332 6.93334C13.3332 10.468 10.4678 13.3333 6.9332 13.3333Z",
      stroke: "#484848"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }